import { Action, createReducer, on } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { InstutionUser } from './instution-user.model';
import * as InstutionUserActions from './instution-user.actions';

export const instutionUsersFeatureKey = 'instutionUsers';

export interface State extends EntityState<InstutionUser> {
  // additional entities state properties
}

export const adapter: EntityAdapter<InstutionUser> = createEntityAdapter<InstutionUser>();

export const initialState: State = adapter.getInitialState({
  // additional entity state properties
});

export const reducer = createReducer(
  initialState,
  on(InstutionUserActions.addInstutionUser,
    (state, action) => adapter.addOne(action.instutionUser, state)
  ),
  on(InstutionUserActions.upsertInstutionUser,
    (state, action) => adapter.upsertOne(action.instutionUser, state)
  ),
  on(InstutionUserActions.addInstutionUsers,
    (state, action) => adapter.addMany(action.instutionUsers, state)
  ),
  on(InstutionUserActions.upsertInstutionUsers,
    (state, action) => adapter.upsertMany(action.instutionUsers, state)
  ),
  on(InstutionUserActions.updateInstutionUser,
    (state, action) => adapter.updateOne(action.instutionUser, state)
  ),
  on(InstutionUserActions.updateInstutionUsers,
    (state, action) => adapter.updateMany(action.instutionUsers, state)
  ),
  on(InstutionUserActions.deleteInstutionUser,
    (state, action) => adapter.removeOne(action.id, state)
  ),
  on(InstutionUserActions.deleteInstutionUsers,
    (state, action) => adapter.removeMany(action.ids, state)
  ),
  on(InstutionUserActions.loadInstutionUsers,
    (state, action) => adapter.setAll(action.instutionUsers, state)
  ),
  on(InstutionUserActions.clearInstutionUsers,
    state => adapter.removeAll(state)
  ),
);

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();
